const emptyObject = Object.freeze({});

const emptyList: any[] = [];

const noOp = () => emptyObject;

const stopPropagation = (e: any) => e.stopPropagation();

export { emptyObject, emptyList, noOp, stopPropagation };
